import { forwardRef, useCallback } from 'react';
import { Phone } from 'lucide-react';
import Input from '../Input';
import type { PhoneInputProps } from './PhoneInput.types';
import './PhoneInput.scss';

const formatPhone = (digitsRaw: string): string => {
  let d = digitsRaw.replace(/\D/g, '');
  if (d.startsWith('998')) d = d.slice(3);
  d = d.slice(0, 9);
  const parts: string[] = ['+998'];
  if (d.length > 0) parts.push(' ' + d.slice(0, 2));
  if (d.length > 2) parts.push(' ' + d.slice(2, 5));
  if (d.length > 5) parts.push(' ' + d.slice(5, 7));
  if (d.length > 7) parts.push(' ' + d.slice(7, 9));
  return parts.join('');
};

const extractDigits = (formatted: string): string => formatted.replace(/\D/g, '');

const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(function PhoneInput(
  { value, onChange, label, error, hint, required, disabled, placeholder, iconLeft, className, name, id },
  ref,
) {
  const handle = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const formatted = formatPhone(e.target.value);
      const digits = extractDigits(formatted);
      onChange(formatted, digits);
    },
    [onChange],
  );

  return (
    <Input
      ref={ref}
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      label={label}
      error={error}
      hint={hint}
      required={required}
      disabled={disabled}
      placeholder={placeholder || '+998 90 123 45 67'}
      iconLeft={iconLeft ?? <Phone size={16} />}
      className={['phone-input', className || ''].filter(Boolean).join(' ')}
      name={name}
      id={id}
      value={value}
      onChange={handle}
    />
  );
});

export default PhoneInput;
